module.exports = "/static/assets/3c7608dfd1da91a40b301d96e253794b.svg";